module.exports = __webpack_public_path__ + "img/sumdes_1248.cce8565b.png";